<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view/>
    <floating-home-button />
  </div>
</template>

<script>
import FloatingHomeButton from '@/components/FloatingHomeButton.vue'
export default {
   name: 'App',
  components: {
    FloatingHomeButton
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.el-input__inner{
  font-weight: bold;
}
// .el-input .el-input__icon{
//   font-size: 20px;
// }
</style>
